// extracted by mini-css-extract-plugin
export default {"root":"I722VNd_lqLxSwfhccHi","panel":"hEzb5kssVTtPJSSq3tlT"};